import { Navigate } from "react-router-dom";

const readAuth = () => {
  try {
    const raw = localStorage.getItem("aerovoltAuth");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const RequireAuth = ({ children, role }) => {
  const auth = readAuth();
  if (!auth) return <Navigate to="/login" replace />;
  if (role && auth.role !== role) return <Navigate to="/login" replace />;
  return children;
};

export default RequireAuth;
